export const DA = {
  preparing_zip: "Forbereder zip…",
  compressing: "Komprimerer…",
  info_icon: "Når den er markeret som fuldført, kan ingen yderligere medlemmer deltage eller tilføjes, og alle chatgrupper vil blive deaktiveret. Bemærk venligst, at projektet, sammen med alle chatgrupper og data, forbliver tilgængeligt i en deaktiveret tilstand.",
  mark_is_done: "Er du sikker på, at du vil markere projektet som fuldført? Når det er markeret, kan ingen yderligere medlemmer deltage eller tilføjes, og alle chatgrupper vil blive deaktiveret. Bemærk venligst, at projektet, sammen med alle chatgrupper og data, forbliver tilgængeligt i en deaktiveret tilstand.",
  mark_not_done: "Er du sikker på, at du vil genåbne projektet? Når det er markeret som åbent, kan yderligere medlemmer deltage eller tilføjes, og alle chatgrupper vil blive reaktiveret.",
  mark_as_completed: "Marker projekt som fuldført",
  room_completed: "Projekt fuldført",
  room_members: "Projektets medlemmer",
  deactivated_rooms: "Deaktiverede projekter",
  deactivated_chats: "Deaktiverede chats",
  completed_rooms: "Fuldførte projekter",
  request_to_join_a_room: 'Anmodning om at deltage i projektet',
  wants_to_rejoin_room: 'Username vil gerne deltage i projektet Roomname igen.',
  invited_you_to_join_room: 'Username har inviteret dig til at deltage i projektet Roomname.',
  restart: "Genstart",
  update_text: "En ny opdatering er tilgængelig. Klik på genstart for at installere opdateringen.",
  update_availble: "Opdatering tilgængelig",
  Loading: "Indlæser...",
  logout: "Log ud",
  back: 'Tilbage',
  company_list: "Firmaliste",
  followers: "Følgere",
  followings: "Følger",
  article: "Artikel",
  companies: "Firmaer",
  one_to_one_chat: " En-til-en chat",
  profile: "Profil",
  company: "Firma",
  company_selection: "Firmaval",
  home: "Hjem",
  contact: "Kontakt ",
  add_company: "Tilføj firma ",
  add_project: "Tilføj projekt ",
  capacities: "Kapaciteter ",
  work_area: "Arbejdsområde",
  company_services: "Firmas tjenester",
  website: "Hjemmeside",
  search_contacts: "Søg kontakter",
  add_or_join_a_company: "Tilføj eller deltag i et firma",
  follow: "Følg",
  following: "Følger",
  like: "Synes godt om",
  company_contacts: "Firmakontakt",
  leave_the_company: "Forlad firmaet",
  news: "Nyheder",
  earlier: "Tidligere",
  action: "Handling",
  another_action: "En anden handling",
  something_else: "Noget andet",
  search: "Søg",
  search_rooms: "Søg projekter",
  search_articles: "Søg artikler",
  contacts: "Kontakter",
  suggestions: "Forslag",
  project_list: "Projektliste",
  search_results: "Søgeresultater",
  add_or_join_project: "Tilføj eller deltag i projekt",
  details: "Detaljer",
  your_position_within_company:
    "Vælg venligst din stilling i firmaet.",
  close_modal: "Luk",
  map: "Kort",
  or: "Eller",
  name: "Navn*",
  street: "Gade*",
  house_number: "Husnummer",
  postal_code: "Postnummer",
  city: "By*",
  opened_by: "Åbnet af:",
  project_No: "Projektnummer: ",
  building_type: "Bygningstype*",
  building_types: "Bygningstype",
  add_join: "Tilføj/Deltag",
  mandatory_fiels: "*obligatoriske felter",
  invalid_fiels: "Dette felt er påkrævet",
  add_or_join_company: "Tilføj eller deltag i firma",
  name_of_the_company: "Firmas navn",
  edit_company_details: "Rediger firmadetaljer",
  branch_of_the_building_industry: "Gren af byggeindustrien",
  corporate_form: "Selskabsform",
  position_within_company: "Stilling i firmaet",
  request_confirmation: "Ventende projektanmodninger",
  company_e_mail: "Firmas e-mail",
  type_of_filter: "Skriv for at filtrere...",
  setting: "Indstilling",
  dashboard: "Dashboard",
  settings: "Indstillinger",
  views: "Visninger",
  times_seen: "gange set",
  see_more: "...mere",
  see_less: "...mindre",
  in_search: "i søgningen",
  reset_password: "Nulstil adgangskode",
  submit: "Send",
  password: "Adgangskode",
  email: "E-mail",
  confirm_password: "Bekræft adgangskode",
  reset_email: "Nulstil e-mail",
  update: "Opdater",
  new_email: "Ny e-mail",
  kjuup_message: "Kjuup Besked",
  delete_profile: "Slet profil?",
  my_position: "Min stilling:",
  add: "tilføj",
  owner_company_admin: "Firmaadministrator :",
  owner_company_admin_new: "Firmaadministrator",
  mutual_contact: "fælles kontakt",
  mutual_contacts: "fælles kontakter",
  co_owner: "Medejer",
  managing_director: "Administrerende direktør",
  associate: "Medarbejder",
  secretary: "Sekretær",
  employee: "Medarbejder",
  project_manage: "Projektleder",
  auto_chat_translation: "Automatisk chatoversættelse",
  translate_room_group_names: "Oversæt chatgruppenavne",
  translate_room_group_names_info: "Når det er aktiveret, oversættes chatgruppenavne automatisk til dit grænsefladesprog.",
  default_view_email: "Default View: E-Mail",
  default_view_email_info: "Når aktiveret, åbnes E-Mail-fanen som standard i stedet for Beskeder, når du åbner appen.",
  integrate_email_in_messages: "Integrate E-Mail in Messages",
  integrate_email_in_messages_info: "When enabled, emails from all connected accounts will appear alongside your chat messages, sorted by date.",
  language: "Sprog",
  english: "Engelsk",
  german: "Tysk",
  french: "Fransk",
  italian: "Italiensk",
  change_language: "Skift sprog",
  my_companies: "Mine firmaer",
  employees: "Medarbejdere",
  invite_with_a: "Inviter til Kjuup",
  add_member: "Tilføj medlem",
  add_user: "Tilføj bruger",
  send_location: "Send placering",
  assign_admin_rights: "Juster administratorret",
  deactivate_company: "Deaktiver firma",
  remove_employees: "Fjern medarbejdere",
  remove_members: "Fjern medlemmer",
  no_user_found: "Ingen bruger fundet!",
  approve: "Godkend!",
  deselect_all: "Fjern valg af alle",
  select_all: "Vælg alle",
  translation_on_building_projects: "Oversættelse i projekter",
  reported_capacities: "Rapporterede tjenester",
  up_to_50m_exact: "Op til 50m præcist",
  company_details_service: "Firmas tjenester",
  company_contact: "Firmakontakt",
  invite_with_link: "Inviter til Kjuup",
  share_link: "Del link",
  share_company_link: "Del link",
  qr_code: "QR-kode",
  copy_link: "Kopier link",
  cancel_link: "Annuller link",
  who_has_confirmed_services: "Hvem har bekræftet dine tjenester?",
  projectss: "Projekter",
  add_services: "Tilføj tjenester",
  services: "Tjenester",
  save_text: "Gem",
  share_on: "Del på:",
  articlen: "Artikel",
  invite_user_to_confirm_service:
    "Inviter brugere til at bekræfte tjenester til firmaet.",
  link_copied: "Link kopieret!",
  email_copied: "E-mail kopieret!",
  personal_article: "Personlig artikel",
  company_article: "Firmaartikel",
  characters_remaining: "Resterende tegn",
  optional_information: "Valgfri information",
  project: "Projekt",
  projects: "Projekter...",
  abort: "Kassér",
  preview: "Forhåndsvisning",
  post: "Send",
  of: "af",
  remove: "Fjern",
  free_capacity: "Jobportal",
  current_status_overview: "Oversigt over nuværende status",
  report_capacities: "Rapporter tjenester",
  report_text: "Rapporter",
  search_capacities: "Find entreprenører",
  add_project_user: "Tilføj projektbruger",
  media: "Media",
  links: "Links",
  docs: "Dokumenter",
  featured_products: "Udvalgte produkter...",
  title: "Titel",
  text: "Tekst",
  feed_details: "Feed-detaljer",
  add_employee: "Tilføj medarbejder",
  latest: "Seneste",
  my_projects: "Mine projekter",
  cancel: "Annuller",
  continue: "Fortsæt",
  role_in_the_building_industry: "Rolle i byggeindustrien",
  als: "som",
  join: "deltag",
  find: "Find",
  request_to_join_a_company: "Anmodning om at deltage i firmaet",
  wants_to_join_the_company: "ønsker at deltage i firmaet",
  filter_by: "Filtrer efter",
  ok: "Ok",
  close: "Luk",
  weekly_statistics: "Ugestatistik",
  is_following_you: "følger dig.",
  as: "som",
  has_joined_the: "har deltaget i firmaet",
  has_looked_at_your_profile: "har set på din profil.",
  time: "Tid",
  in_searches_in_past_week: "i søgninger sidste uge.",
  has_liked_your_article: "har synes godt om din artikel.",
  has_published_a_new_article: "har publiceret en ny artikel.",
  you: "Du",
  all_views: "Alle visninger",
  all_profile_views: "Alle profilvisninger",
  mutual_company: "fælles firma",
  artical_text: "Skriv artikel...",
  you_have_appeared: "Du er dukket op",
  your_request_at_the_company: "Din anmodning i firmaet",
  times_you_have_appeared_in_searches: "gange du er dukket op i søgninger",
  appear_more_often_in_searches: "Duk op oftere i søgninger",
  you_have_been_found: "Du er blevet fundet",
  improve_profile: "Forbedre profil",
  choose_existing_contact_for_single_chat:
    "Vælg eksisterende kontakt til enkelt chat:",
  in_order_to_add_new_contacts:
    "For at tilføje nye kontakter, søg venligst efter nye kontakter på profilsiden.",
  times_in_searches_in_the_last_week:
    "gange i søgninger sidste uge. Opdater din profil og tilføj flere detaljer for at blive fundet lettere.",
  has_been_confirmed: "er blevet bekræftet.",
  have_joined_the: "har deltaget i  ",
  building_project: " byggeprojekt.",
  select_with_which_company_you_want_to_connect_to_the_project:
    "Vælg firmaet, du vil repræsentere. Dette vil blive vist til andre deltagere.",
  select_with_which_company_you_want_to_connect_to_the_chat:
    "Vælg firmaet, du vil repræsentere. Dette vil blive vist til andre deltagere.",
  select_internal_section: "Vælg venligst intern sektion",
  select_profile_image: "Vælg profilbillede",
  share_user: "Del bruger",
  contact_sender_message:
    "Del dette link for at invitere en ikke-medlem af Kjuup til Kjuup. Dette link kan bruges af flere personer til at registrere sig.",
  project_sender_message:
    "Del dette link for at invitere en ikke-medlem af Kjuup til projektet projektnavn. Dette link kan bruges af flere personer til at registrere sig og deltage i projektet projektnavn i Kjuup.",
  company_sender_message:
    "Del dette link for at invitere en ikke-medlem af Kjuup til firmaet firmasnavn. Dette link kan bruges af flere personer til at registrere sig og deltage i firmaet i Kjuup.",
  contact_receivers_message:
    "Invitationslink til at deltage i Kjuup. Klik venligst på linket for at registrere dig for kjuup.",
  iphone: "iPhone:",
  iphone_recivers_message:
    "Hvis du installerer Kjuup via Apple App Store, skal du klikke på dette link efter vellykket download for at kunne registrere dig.",
  project_receivers_message:
    "Invitationslink til at deltage i projektet projektnavn i Kjuup. Klik venligst på linket for at registrere dig for Kjuup og deltage i projektet projektnavn.",
  company_receivers_message:
    "Invitationslink til firmaet firmasnavn i Kjuup. Klik venligst på linket for at registrere dig for Kjuup og deltage i firmaet firmasnavn.",
  sign_in: "Log ind",
  enter_your_email_add: "Indtast din e-mailadresse",
  forgot_password: "Glemt adgangskode",
  dont_have_account: "Har du ikke en konto?",
  register: "Registrer",
  get_app: "Hent appen",
  registration: "Registrering",
  dep_ing: "Dipl.-Ing.",
  dr: "Dr.",
  dr_ing: "Dr.-Ing.",
  dep_ing_arc: "Dipl.-Ing. Arkitekt",
  prof: "Prof.",
  first_name: "Fornavn",
  last_name: "Efternavn",
  have_an_account: "Har du en konto?",
  when_register_you_agree: "Når du registrerer dig, accepterer du vores",
  term_of_use: "brugsvilkår",
  to: ".",
  in_our: "I vores",
  data_policy: "datapolitik",
  they_find_out: "finder du ud af,",
  we_provide_store_data: "hvordan vi indsamler, behandler og opbevarer information.",
  leaving_company_text:
    "Vil du virkelig forlade firmaet? Når du forlader firmaet, forlader du også alle tilknyttede projekter og chatgrupper. Du kan deltage i disse projekter igen med et andet firma når som helst.",
  delete_profile_text:
    "Vil du virkelig slette din profil? Når du sletter din profil, vil alle forbindelser til firmaer, projekter og chats blive fjernet. Du kan oprette en ny profil når som helst.",
  confirm: "Bekræft",
  reject: "Afvis",
  requet_to_leave: "Anmodning om at forlade",
  choose: "Vælg",
  your_add_member: "Tilføj medlem",
  if_you: "hvis du",
  can_not_find: "ikke kan finde din kontakt her.",
  please_wait: "Vent venligst..",
  imprint_gtc: "Impressum/Generelle vilkår",
  register_confirm_popup: "Bekræft din Kjuup-e-mailadresse, før du logger ind. Vi har sendt et bekræftelseslink. Hvis du ikke kan se det, tjek også spam-mappen.",
  PENDING_GROUP_USER:
    "vil kun modtage beskeder efter at invitationen til projektet er blevet bekræftet. En ekstra besked vil vises, når invitationen til projektet er blevet bekræftet.",
  PENDING: "Bekræftelse af invitation til projektet afventer",
  denied_group_chat: " har afvist invitationen til projektet og har forladt denne gruppe.",
  // joined_group_chat: " har deltaget i rummet og denne gruppe.",
  joined_group_chat: " deltog i denne gruppe",
  you_joined_group_chat: "Du deltog i denne gruppe.",
  Others: "Andre",
  LEFT_GROUP: "har forladt denne chatgruppe.",
  YOU_LEFT_GROUP: "har forladt denne chatgruppe.",
  days: "dage",
  day: "dag",
  hour: "time",
  hide_project: "Skjul projekt",
  hide_project_popup_text:
    "Hvis du skjuler projekter, kan de ikke findes i Kjuup. Kun medlemmer af projektet kan invitere nye brugere til projektet.",
  branch: "Gren",
  photo_video_media_lib: "Foto - Video mediebibliotek",
  document: "Dokument",
  location_meeting: "Placering / Møde",
  all_member_of_project: "Alle medlemmer af projektet",
  pending_request: "Ventende projektanmodninger",
  no_pending_request: "Ingen ventende anmodninger fundet!",
  news_feed: "Nyhedsfeed",
  user_info: "Gruppeinfo",
  leave_project: "Forlad projekt",
  media_link_docs: "Filer",
  search_chat: "Søg chat",
  export_chat_group: "Eksporter chatgruppedata fra sidste måned",
  request_complete_chat_history: "Anmod om komplet chat historik",
  leave_chat_group: "Forlad chatgruppe",
  add_user_project: "Tilføj bruger",
  me: "Mig",
  max_open_one_to_one:
    "I øjeblikket kan maks. 2 en-til-en chats åbnes parallelt i nederste og øverste sektion. I alt er maks. 4 en-til-en chats mulige.",
  are_you_sure_you_want_leave_chat:
    "Er du sikker på, at du vil forlade denne chatgruppe?",
  create_group: "Opret gruppe",
  adding_members: "Tilføjer medlemmer...",
  creating_the_chat: "Opretter chatten...",
  finishing_setup: "Færdiggør...",
  group_name: "Gruppenavn",
  by: "Af:",
  mandetory: "*obligatorisk",
  delteed: "har slettet sin profil og har forladt gruppechatten.",
  deleted_direct: "har slettet sin profil og har forladt chatten.",
  unhidden_message:
    "Hvis du viser projekter, kan de findes af alle medlemmer af Kjuup.",
  account_deleted: "Kontoen er blevet slettet.",
  refuse_company: "Er du sikker på, at du vil afvise firmaets invitation?",
  follow_additional: "Følg yderligere brugere",
  f_add:
    "Følg yderligere brugere af Kjuup for at gøre dem tilgængelige for direkte beskeder.",
  c_inv: "Firmainvitation(er)",
  invited_o_Company: "Du er blevet inviteret til at deltage i firmaet",
  refuse_companyX: "Er du sikker på, at du vil afvise firmaets anmodning?",
  a_Da: "Konto deaktiveret.",
  has_deactivated: "har deaktiveret sin profil.",
  reactive: "har reaktiveret sin profil.",
  juup_note: "*Registrering med brugernavn kun tilgængelig for medlemmer af Kjuup+",
  username: "Brugernavn*",
  email_username: "E-mail/Brugernavn*",
  sPinText:
    "Angiv venligst en 6-cifret sikkerheds-PIN. Denne PIN vil være nødvendig, hvis du glemmer din adgangskode, og er obligatorisk for at bekræfte din konto.",
  DeleteKjuupPlusText:
    "Vil du virkelig slette din profil? Når du sletter din profil, vil alle forbindelser til firmaer, projekter og chats blive fjernet.\n\nInden for 48 timer efter kontosletning kan du reaktivere din konto ved at logge ind med brugernavn, adgangskode og PIN.",
  reactive_text:
    "Din konto er blevet slettet. Klik venligst på Reaktiver for at reaktivere din konto.",
  rac: "Reaktiver",
  ac_ss: "Kontoen er blevet reaktiveret succesfuldt.",
  not_valid_pin: "PIN ugyldig",
  only_for_kjuup:
    "*Nulstilling af adgangskode via brugernavn og PIN kun tilgængelig for Kjuup+ medlemmer.",
  resetPIN: "Nulstil PIN",
  enter_current_pin: "Indtast venligst din nuværende PIN",
  enter_new: "Indtast ny PIN",
  pin_to_confirm: "Angiv venligst PIN'en for at bekræfte.",
  change_username: "Nulstil brugernavn",
  pp_not_match: "Adgangskode og Bekræft adgangskode stemmer ikke overens",
  reactive_itself: "Du har reaktiveret din profil.",
  has_deactivated_itself: "Du har deaktiveret din profil.",
  more_than_two:
    "I øjeblikket kan direkte beskeder kun sendes med 2 brugere parallelt.",
  Chats: "Direkte beskeder",
  only_in_mobileL:
    "Indbyggede videoer kan i øjeblikket kun uploades og sendes via mobilappen. Brug venligst videolinks fra Youtube og Vimeo.",
  register_pin_text:
    "Vælg venligst din personlige 6-cifrede PIN. Denne PIN vil være nødvendig for at aktivere kontonulstillingsfunktioner.",
  internal_project: "Intern",
  external_projects: "Ekstern",
  in_deacticted: "Intern sektion er deaktiveret.",
  create_article: "Opret artikel",
  new_article_selection: "Opret artikel til ekstern nyhedsfeed",
  new_article_selection_internal: "Opret intern artikel",
  active_trans_title: "Slå automatisk oversættelse til?",
  active_trans: "Når den er aktiveret, vil alle indkommende chatbeskeder blive oversat til dit valgte appsprog.",
  disable_trans: "Vil du virkelig deaktivere automatisk oversættelse?",
  allow_access_chat: "Vis fuld chat historik",
  toggle_chat_history_on:
    "Vil du virkelig, at brugeren skal se fuld chat historik?",
  toggle_chat_history_off:
    "Vil du virkelig, at brugeren kun skal se chat historikken fra det tidspunkt, de deltog i chatten?",
  check_selected_settings:
    "Tjek venligst indstillingerne for chat historik for alle valgte brugere!",
  chat_from_start_have:
    "Du har deltaget i denne gruppe. Chat historikken er blevet delt.",
  chat_from_start_has:
    "har deltaget i denne gruppe. Chat historikken er blevet delt.",
  Address: "Adresse",
  read_by: "Læst af",
  deliver_to: "Leveret til",
  remaining: "resterende",
  message_info: "Beskedinfo",
  request_to_join_only: "Anmodning om at deltage",
  unfollow: "Stop med at følge",
  company_username: "Brugernavn",
  month: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "Maj",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dec",
  ],
  remove_my_admin_right: "Fjern mine administratorrettigheder",
  makeEmp: "Vil du virkelig fjerne firmaadministratorrettigheder fra brugeren?",
  remove_my_self:
    "Vil du virkelig fjerne firmaadministratorrettigheder fra din konto?",
  makeAdmin: "Vil du virkelig give brugeren firmaadministratorrettigheder?",
  remove_member: "Fjern medlem",
  remove_following_confirm: "Vil du virkelig fjerne {name} fra listen over fulgte?",
  remove_follower_confirm: "Vil du virkelig fjerne {name} fra dine følgere? Hvis du fjerner ham/hende vil han/hun ikke blive informeret.",
  do_you_really_want_to_remove:
    "Vil du virkelig fjerne brugernavnet fra firmaet?",
  invite_all: "Inviter alle medlemmer af firmaet",
  invite_all_members: "Inviter alle medlemmer",
  mems: "Alle andre medlemmer",
  dep_loc: "Afdeling/Placering/Team",
  depAdmin: "Afdelsingsadministrator",
  add_remove_admin: "Tilføj/Fjern firmaadministratorstilling",
  add_remove_dep_admin: "Tilføj/Fjern afdelingsadministratorstilling",
  remove_employees_dept: "Fjern medarbejdere fra",
  want_to_join_dep:
    "Brugernavn ønsker at deltage i Afdelingen/Placeringen/Teamet depname af firmaet companyname.",
  you_invited:
    "Du er blevet inviteret til at deltage i Afdelingen/Placeringen/Teamet depname af firmaet companyname.",
  dep_remove:
    "Vil du virkelig fjerne administratorrettigheder for afdeling eller placering fra brugeren?",
  add_dep:
    "Vil du virkelig give brugeren administratorrettigheder for afdelingen eller placeringen?",
  my_self_dep_remove:
    "Vil du virkelig fjerne afdelingsadministratorrettigheder fra din konto?",
  member: "Medlem",
  admin: "Administrator",
  remove_project_admin:
    "Vil du virkelig fjerne medlemmet fra projektet?",
  remove_my_self_project: "Vil du virkelig fjerne administratorrettigheder?",
  remove_member_admin_right:
    "Vil du virkelig fjerne administratorrettigheder fra brugeren?",
  add_member_admin_right: "Vil du virkelig tilføje administratorrettigheder til brugeren?",
  add_remove_Poss: "Tilføj/Fjern administratorstilling",
  forward: "Videresend",
  edit: "Rediger",
  only_kjuup_plus_can: "Kun Kjuup+ firmaer kan sende artikler.",
  add_images: "Tilføj billede(r)",
  request_confirmation: 'Ventende projektinvitationer',
  Activity: "Aktivitet",
  latest_messages: "Seneste beskeder",
  hours: "timer",
  minute: "minutter",
  seconds: "sekunder",
  days: "dage",
  yesterday: "i går",
  last_week: "sidste uge",
  next_week: "næste uge",
  Last_month: "sidste måned",
  All: "Alle",
  register_plus: "Registrering Plus",
  select_files: "Vælg filer",
  monthsFullName: [
    "Januar",
    "Februar",
    "Marts",
    "April",
    "Maj",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "December",
  ],
  company_deploc_receivers_message:
    "Invitationslink til afdelingen af firmaet firmasnavn i Kjuup. Klik venligst på linket for at registrere dig for Kjuup og deltage i firmaet firmasnavn.",
  no_news: "Ingen nyheder tilgængelige",
  reminder: "Påmindelse",
  np_reminder: "Ingen opgaver",
  move_to_reminder: "Flyt til opgave",
  remove_reminder: "Vil du virkelig fjerne denne besked fra listen over dine opgaver?",
  remove_all_reminder: "Fjern alle opgaver",
  remove_all_confirm: "Vil du virkelig fjerne alle beskeder fra listen over dine opgaver?",
  remove_from_reminder: "Fjern fra påmindelse",
  prevent_email: "E-mail kan ikke bruges som Brugernavn.",
  allow_noti: "Tillad venligst notifikationer.",
  join_cap: "Deltag",
  pass_minimum:
    "**Adgangskode kræver 12 tegn inkl. lille bogstav, stort bogstav, tal og specialtegn.",
  pass_error: "Tjek venligst adgangskodekravene",
  people_that_like_article: "Folk, der kan lide artiklen.",
  people_who_like_article: "Folk, der kan lide din artikel.",
  message_delete: "Denne besked er blevet slettet.",
  message_edited: "redigeret",
  edit_message: "Rediger besked",
  edit_window_expired: "Beskeder kan kun redigeres inden for 10 minutter efter afsendelse.",
  message_edit_save: "Gem",
  copy: "Kopiér",
  bookmark: "Bogmærke",
  add_reaction: "Tilføj reaktion",
  delete_message: "Slet besked",
  more_options: "Flere indstillinger",
  info: "Info",
  link_invite: "Inviter via link",
  ll_nkk: "Inviter til Kjuup",
  selected: "Valgt",
  is_active: "Aktiv",
  inactive: "Inaktiv",
  last_online: "sidst online {{when}}",
  remove_user_l: "Fjern",
  link_expire: "Hvert genereret link vil være gyldigt i 72 timer.",
  company_language: "Firmasprog",
  company_language_info:
    "Sprogvalget vil blive brugt til alle e-mailbekræftelser vedrørende firmaet.",
  s_image: "billede",
  m_image: "billeder",
  removeMsg: "Tryk for at fjerne",
  block: 'Bloker',
  unblock: 'Fjern blokering',
  blocks: 'Er du sikker på, at du vil blokere denne bruger?',
  unblocks: 'Er du sikker på, at du vil fjerne blokeringen af denne bruger?',
  bolcked_click_un_block:
    'Du har blokeret denne kontakt. Klik her for at fjerne blokeringen.',
  you_have_unblocked: 'Du har fjernet blokeringen af denne kontakt.',
  you_have_blocked: 'Du har blokeret denne kontakt.',
  unblock_to_send: 'Fjern blokering af bruger for at sende besked.',
  pilot_text: "Specialiseret AI til byggetemaer",
  startup_screen_label: "Startskærm",
  startup_screen_info: "Vælg hvilken skærm der åbnes, når Kjuup starter.",
  startup_screen_feed: "Home",
  startup_screen_messages: "Beskeder",
  startup_screen_saved: "Startskærm opdateret",
email_on: "E-mailnotifikationer for chats",
  email_on_grp: "E-mailnotifikation",
  article_email_on: "Email notification articles",
  article_email_info: "If you enable email notifications for internal articles, you will receive an email when a new internal article is published in your company and department.",
  info_email_room: "Aktivér eller deaktivér e-mailnotifikationer for dette projekt. Denne mulighed er kun tilgængelig, når \"E-mailnotifikationer for chats\" er aktiveret via personlige indstillinger.",
  todo_notification_info: "Du får besked, hver gang en ny opgave bliver tildelt dig.",
  info_val: "Du får en e-mail, hvis en ny chatbesked ikke bliver læst inden for kort tid. Du kan slå det fra for bestemte projekter eller chats i deres indstillinger eller i chatgruppens info.",
  email_groups: "Aktivér eller deaktivér e-mailnotifikationer for denne chat. Denne mulighed er kun tilgængelig, når \"E-mailnotifikationer for chats\" er aktiveret via personlige og projektindstillinger.",
  add_update_email: "Tilføj/Opdater e-mail",
  text_to_verifiy: "Muligheden \"E-mailnotifikationer for chats\" kan kun aktiveres, hvis du har en bekræftet e-mailadresse i filen.",
  stored_email: "Gemt e-mail: ",
  verify_email: "Bekræftelse afventer!",
  join_call:"Deltag",
  call_is_started:"Opkald er startet",
  start_chat:"Start direktechat?",
  project_rooms:"Projekter",
  download_selected:"Download",
  add_employee_confirm: 'Er du sikker på, at du vil tilføje denne bruger til firmaet?',
  invalid_deeplink: "Ugyldig dyblink-URL. Manglende påkrævede parametre.",
  deeplink_error: "Kan ikke behandle dyblink. Prøv venligst igen senere.",
  // Reply functionality translations
  reply: "Svar",
  reply_enter: "Indtast svar...",
  reply_sent_successfully: "Svar sendt succesfuldt",
  reply_failed: "Kunne ikke sende svar",
  reply_failed_generic: "Kunne ikke sende svar. Prøv venligst igen.",
  replying_to_message: "Svarer på besked",
  cancel_reply: "Annuller svar",
  voice_message: "Stemmebesked",
  send: "Send",
  cancel: "Annuller",
  type_your_reply: "Skriv dit svar...",
  
  // Auto-suggestion translations
  suggested_replies: "Foreslåede svar",
  suggestions_error: "Kunne ikke indlæse forslag",
  positive_suggestion_placeholder: "Positive",
  neutral_suggestion_placeholder: "Neutral",
  negative_suggestion_placeholder: "Negative",
  lazy_media_image: "Billede — Klik for at indlæse",
  lazy_media_audio: "Talebesked — Klik for at indlæse",
  lazy_media_doc: "Dokument — Klik for at indlæse",
  lazy_media_video: "Video — Klik for at indlæse",
  suggestion_loading_message: "Et øjeblik. Din tekst forberedes individuelt til dig.",
  loading_chat_message: "Indlæser chat...",
  
  // Manual ToDo translations
  extracting_message: "Udtrækker besked...",
  create_todo: "Opret opgave",
  create_todo_confirmation: "Vil du oprette en opgave fra denne besked?",
  select_project_required: "Vælg venligst et projekt/gruppe",
  only_assigned_can_change_status: "Kun tildelte brugere kan ændre status",
  todo_summary: "Resumé",
  todo_summary_placeholder: "Indtast opgavesammendrag...",
  todo_date: "Dato",
  todo_time: "Tid",
  todo_date_hint: "Lad stå tomt for at bruge original beskeddato/tid",
  todo_created_success: "Opgave oprettet succesfuldt",
  todo_creation_failed: "Kunne ikke oprette opgave",
  create: "Opret",
  
  image: "billede",
  images: "billeder",
  remove_all_images: "Fjern alle billeder",
  remove_image: "Fjern billede",
  remove_document: "Fjern dokument",
  remove_recording: "Fjern optagelse",
  play_recording: "Afspil optagelse",
  upload_image: "Upload billede",
  upload_document: "Upload dokument",
  record_audio: "Optag lyd",
  stop_recording: "Stop optagelse",
  stop_recording_text: "Stop optagelse",
  please_remove_current_attachment: "Fjern venligst nuværende vedhæftning for",
  please_upload_image_file: "Upload venligst en gyldig billedfil",
  please_upload_valid_document: "Upload venligst en gyldig dokumentfil",
  searching_messages: "Søger beskeder...",
  loading_more: "Indlæser mere...",
  loading_more_users: "Indlæser flere brugere...",
  load_more_users: "Indlæs flere brugere",
  no_more_users_to_load: "Ingen flere brugere at indlæse",
  no_messages_found: "Ingen beskeder fundet",
  try_different_keyword: "Prøv et andet nøgleord eller tjek din stavning.",
  search_messages: "Søg beskeder, chatgrupper, projekter og brugere...",
  todo: "Opgave",
  np_todo: "Ingen opgaver",
  move_to_todo: "Gem som opgave",
  remove_todo: "Vil du virkelig fjerne opgaven?",
  remove_all_todo: "Fjern alle opgaver",
  remove_all_todo_confirm: "Vil du virkelig fjerne alle opgaver?",
  add_to_todo: "Tilføj til opgave",
  remove_from_todo: "Fjern fra opgave",
  confirm: "Bekræft",
  ok: "Ok",
  read_more: "Læs mere",
  show_less: "Vis mindre",
  show_more: "Vis mere",
  audio: "Lyd",
  video: "Video",
  // Notification Settings
  notification_schedule: "Notifikationsplan",
  notification_schedule_desc: "Du vil kun modtage push- og e-mail-notifikationer i de timer, du vælger. Uden for disse tidspunkter sættes de på pause.",
  learn_more: "Lær mere",
  allow_notifications: "Tillad notifikationer:",
  every_day: "Hver dag",
  weekdays: "Hverdage (mandag til fredag)",
  custom: "Tilpasset",
  monday: "Mandag",
  tuesday: "Tirsdag",
  wednesday: "Onsdag",
  thursday: "Torsdag",
  friday: "Fredag",
  saturday: "Lørdag",
  sunday: "Søndag",
  to: "til",
  notification_settings: "Notifikationer",
  notification_settings_saved: "Notifikationsindstillinger gemt succesfuldt",
  notification_settings_error: "Kunne ikke gemme notifikationsindstillinger",
  unavailability_note: "Fraværsbesked",
  unavailability_description: "Indstil en fraværsbesked. Mens den er aktiv, vises beskeden for andre i alle dine chats, og notifikationer sættes på pause.",
  unavailability_start_date: "Startdato",
  unavailability_end_date: "Slutdato",
  unavailability_message: "Besked",
  unavailability_message_hint: "Brug {endDate} som pladsholder for din returdato.",
  unavailability_replacement: "Erstatningskontakt",
  unavailability_replacement_placeholder: "Indtast bruger-ID for hastende henvendelser",
  unavailability_replacement_current: "Nuværende erstatning",
  unavailability_replacement_hint: "Hvis angivet, vises et link til at kontakte denne person for hastende sager i din fraværsbesked.",
  unavailability_replacement_none: "Ingen erstatning (valgfrit)",
  unavailability_contact_urgent: "For hastende henvendelser kontakt",
  unavailability_default_message: "Jeg er i øjeblikket ikke på kontoret og har ikke adgang til Kjuup. Jeg er tilgængelig igen fra {endDate} og vender tilbage til dig da.",
  unavailability_save: "Gem",
  unavailability_deactivate: "Deaktivér",
  unavailability_active_until: "Aktiv indtil",
  unavailability_saved: "Fraværsbesked gemt",
  unavailability_save_error: "Fraværsbesked kunne ikke gemmes",
  unavailability_deactivated: "Fraværsbesked deaktiveret",
  unavailability_end_date_required: "Slutdato er påkrævet",
  start_time_before_end_time: "Starttid skal være før sluttid",
  loading: "Indlæser",
  disabled: "Deaktiveret",
  enable: "Aktivér",
  disable: "Deaktivér",
  forwarded: "Videresendt",
  message_forwarded: "Besked videresendt!",
  // Schedule Article
  schedule_article_post: "Planlæg artikelpublicering",
  date: "Dato",
  time: "Tid",
  scheduled_for_publication: "Planlagt til publicering",
  article_will_be_published_on: "Artiklen vil blive publiceret:",
  reset_selection: "Nulstil valg",
  continue: "Fortsæt",
  cancel: "Annuller",
  // Member Selection
  error_loading_members: "Fejl ved indlæsning af medlemmer",
  please_fill_all_fields: "Udfyld venligst alle felter",
  invalid_email: "Ugyldig e-mailadresse",
  member_added_successfully: "Medlem tilføjet succesfuldt",
  error_onboarding_user: "Fejl ved tilføjelse af bruger",
  error_creating_chat: "Fejl ved oprettelse af chat",
  error_creating_group: "Fejl ved oprettelse af gruppe",
  new_group: "Ny gruppe",
  please_select_or_enter_group_name: "Vælg venligst en gruppe eller indtast et gruppenavn",
  please_select_or_enter_room_name: "Vælg venligst et projekt eller indtast et projektnavn",
  error_creating_room: "Fejl ved oprettelse af projekt",
  error_opening_chat: "Fejl ved åbning af chat",
  privacy_modal_text: "Vælg \"Privat\" kun hvis chatten ikke indeholder relevant professionelt indhold for projektlederen.",
  not_private: "Ikke privat",
  private: "Privat",
  error_loading_groups: "Fejl ved indlæsning af grupper",
  automatic_chat_export: "Automatisk chatteksport",
  automatic_chat_export_info: "Efter aktivering vil chat historikken automatisk blive sendt til den angivne e-mailadresse hver måned.",
  automatic_chat_export_no_email: "For at aktivere automatisk chatteksport skal du først tilføje en e-mailadresse. Du kan tilføje din e-mailadresse i de personlige indstillinger.",
  enter_email: "Indtast e-mail",
  update: "Opdater",
  confirm: "Bekræft",
  export_to_email: "Eksporten går til følgende e-mail.",
  start_chat_button:"Ny besked",
  matching_existing_chats: "Matchende eksisterende chats",
  subject: "Emne",
  add_subject: "Tilføj emne",
  chat_subject: "Chatemne:",
  set_project_room: "Indstil projekt",
  matching_existing_project_rooms: "Matchende eksisterende projekter",
  name_project_room: "Navngiv projekt",
  professional_or_private: "Professionelt eller privat",
  professional: "Professionelt",
  privacy_modal_text_updated: "Vælg \"Privat\" kun hvis chatten ikke indeholder relevant professionelt indhold for projektledere. Private chats er ikke synlige for projektledere.",
  create_internal_chat: "Ekstern - eller intern chat?",
  internal_chat_description: "Kun medarbejdere i dit firma kan tilføjes til interne chats.",
  yes: "Ja",
  no: "Nej",
  chat_is_being_created: "Chatten oprettes...",
  // Additional translations for hardcoded text
  discard_article_confirm: "Vil du virkelig kassere ændringerne i denne artikel?",
  please_enter_article_title: "Indtast venligst artikelens titel først.",
  please_add_mandatory_fields: "Tilføj venligst alle obligatoriske felter",
  product_label: "Produkt:",
  no_companies_found: "Ingen firmaer fundet",
  visible_to_all_followers: "Synlig for alle Kjuup-medlemmer",
  only_visible_to_employees: "Synlig kun for medarbejdere",
  something_went_wrong: "Noget gik galt, prøv venligst igen",
  please_select_department: "Vælg venligst afdeling/placering",
  schedule: "Planlæg",
  please_select_future_date_time: "Vælg venligst en fremtidig dato og tid for at planlægge artiklen.",
  please_select_different_date_time: "Vælg venligst en anden dato eller tid for at planlægge artiklen.",
  please_select_later_time: "Vælg venligst et tidspunkt senere end det nuværende tidspunkt for i dag.",
  unpin_article: "Løsne artikel",
  pin_article: "Fastgør artikel",
  and: "og",
  others: "andre",
  at: "på",
  // Chat mute/unmute translations
  mute: "Dæmp",
  unmute: "Slå dæmpning fra",
  chat_muted_successfully: "Chatten dæmpet succesfuldt",
  chat_unmuted_successfully: "Chatten dæmpning slået fra succesfuldt",
  mute_chat_confirm: "Vil du virkelig dæmpe denne chat? Du vil ikke længere modtage notifikationer for nye beskeder.",
  unmute_chat_confirm: "Vil du virkelig slå dæmpningen fra for denne chat? Du vil modtage notifikationer for nye beskeder igen.",
  please_select_group_to_forward: "Vælg venligst gruppe for at videresende besked",
  // Company translations
  record_not_found: "Post ikke fundet!",
  please_select_position: "Vælg venligst stilling",
  delete_article_confirm: "Er du sikker på, at du vil slette denne artikel?",
  delete_company_service_confirm: "Er du sikker på, at du vil slette firmas tjeneste?",
  block_translation_confirm: "Vil du virkelig blokere automatisk oversættelse i projekter for alle medlemmer af firmaet",
  unblock_translation_confirm: "Vil du virkelig fjerne blokeringen af automatisk oversættelse i projekter for alle medlemmer af firmaet",
  please_select_file: "Vælg venligst en fil at uploade",
  role_in_building_industry: "Rolle i byggeindustrien*",
  invalid_email_address: "Ugyldig e-mailadresse",
  please_enter_password: "Indtast venligst adgangskode",
  password_change_email_sent: "Der er sendt en e-mail til din Kjuup e-mail. Bekræft din nye adgangskode ved at klikke på bekræftelseslinket i e-mailen.",
  please_enter_username: "Indtast venligst brugernavn",
  username_same_as_before: "Brugernavnet kan ikke være det samme som før",
  profile_deleted_successfully: "Profil slettet succesfuldt",
  hardware_requirements: "Hardwarekrav",
  hardware_requirements_list: "• 4GB RAM<br/>• CPU-hastighed min. 2GHz<br/>• Windows 7 eller højere / alle macOS-versioner",
  submitting: "Sender...",
  signing_in: "Logger ind...",
  please_enter_service_name: "Indtast venligst tjenestenavn",
  something_went_wrong_error: "Aaaah! Noget gik galt...",
  something_went_wrong_try_again: "Beklager, noget gik galt der. Prøv igen",
  position_label: "Stilling:",
  loading_room: "Indlæser projekt...",
  navigating_to_room: "Navigerer til projektet",
  loading_chat: "Indlæser chat...",
  translate: "Oversæt",
  show_original: "Vis original",
  saving: "Gemmer...",
  language_selection_info: "Sprogvalget bruges til alle e-mailbekræftelser relateret til firmaet.",
  // Navigation bar labels
  nav_call: "Ring",
  nav_home: "Hjem",
  nav_messages: "Beskeder",
  nav_todo: "To-dos",
  nav_rooms: "Projekter",
  nav_all_rooms: "Alle projekter",
  pinned_rooms_max: "Du kan fastgøre op til 10 projekter.",
  pinned_room_unpin: "Frigør",
  pinned_rooms_drop: "Træk dit projekt herhen for hurtigt valg",
  nav_profile: "Profil",
  nav_company: "Firma",
  nav_company_documents: "Dokumenter",
  nav_logout: "Log ud",
  // Create message dialog
  add_member_title: "Tilføj medlem",
  continue_btn: "Fortsæt",
  search_placeholder: "Søg",
  no_members_found: "Ingen medlemmer fundet",
  no_groups_found: "Ingen grupper fundet",
  no_rooms_found: "Ingen projekter fundet",
  search_users_tab: "Brugere",
  search_documents_tab: "Dokumenter",
  company_documents: "Company documents",
  company_documents_empty: "No documents available.",
  no_media_available: "Ingen filer",
  no_documents_available: "No documents",
  searching_users: "Søger efter brugere...",
  no_users_found: "Ingen brugere fundet",
  search_emails_tab: "E-mail",
  searching_emails: "Søger e-mails...",
  no_emails_found: "Ingen e-mails fundet",
  search_email_addresses_tab: "E-Mail Addresses",
  search_email_content_tab: "E-Mail Content",
  searching_email_content: "Searching email content...",
  no_email_content_found: "No email content found",
  search_email_attachments_tab: "E-Mail Attachments",
  searching_email_attachments: "Searching attachments...",
  no_email_attachments_found: "No attachment matches found",
  email_attachments_label: "Attachments",  searching_email_addresses: "Searching addresses...",
  no_email_addresses_found: "No address matches found",
  email_subject_label: "Subject",
  email_body_label: "Body",
  email_address_received: "Received",
  email_address_sent: "Sent",
  unnamed_group: "Navnløs gruppe",
  unnamed_room: "Navnløst projekt",
  all_members: "Alle",
  room_label: "Projekt:",
  subject_label: "Emne:",
  no_members: "Ingen medlemmer",
  // Loading states for room creation
  creating_structure: "Opretter din struktur",
  opening_chat: "Åbner chatten",
  please_wait: "Vent venligst...",
  // ToDo page translations
  loading_todo: "Indlæser ToDo...",
  task_updated: "Opgave opdateret",
  error_updating_task: "Fejl ved opdatering af opgave",
  task_deleted: "Opgave slettet",
  error_deleting_task: "Fejl ved sletning af opgave",
  delete_task_confirm: "Er du sikker på, at du vil slette denne opgave?",
  description_label: "Beskrivelse",
  description_placeholder: "Indtast beskrivelse...",
  date_time_label: "Dato & Tid",
  save_hint: "Ctrl+Enter for at gemme, Esc for at annullere",
  edit_label: "Rediger",
  delete_label: "Slet",
  todo_list_title: "To-dos",
  tasks_count: "opgaver",
  search_placeholder_todo: "Søg...",
  select_task_to_open_chat: "Vælg en opgave for at åbne chatten",
  today: "I dag",
  yesterday: "I går",
  time_suffix: "", // Empty for Danish (24h format doesn't need suffix)
  from_chat: "Kildeopgave",
  assigned_to: "Tildelt til",
  assign_users: "Tildel brugere",
  no_users_assigned: "Ingen brugere tildelt",
  assign: "Tildel",
  assign_to: "Tildel til...",
  navigate_to_chat: "Naviger til chat",
  navigate_to_email: "Gå til e-mail",
  show_original_message: "Vis kilde",
  hide_original_message: "Skjul kilde",
  status_pending: "Afventer",
  status_in_progress: "I gang",
  status_completed: "Fuldført",
  show: "Vis",
  close: "Luk",
  status_confirmed: "Bekræftet",
  log_todo_created: "Opgave oprettet",
  log_todo_confirmed: "Opgave bekræftet",
  log_todo_deleted: "Opgave slettet",
  log_todo_updated: "Opgave opdateret",
  log_description_updated: "Beskrivelse opdateret",
  log_deadline_updated: "Frist opdateret",
  log_assigned_to: "Tildelt til {name}",
  log_unassigned_from: "Fjernet fra {name}",
  log_assignment_added: "Tildeling tilføjet: {name}",
  log_assignment_removed: "Tildeling fjernet: {name}",
  log_status_updated: "Status ændret fra {from} til {to}",
  log_status_changed: "Status ændret",
  log_status_changed_to: "Status ændret til {status}",
  log_changed_status_to: "Ændrede statussen til:",
  log_for_user: "for bruger:",
  log_user_updated_status: "Bruger opdaterede sin opgavestatus",
  log_changed_date_to: "Ændrede datoen til:",
  log_changed_description_to: "Ændrede beskrivelsen til:",
  log_moved_to: "Flyttet til {status}",
  todo_status_updated_from: "fra",
  todo_status_updated_to: "til",
  filter_pending: "Afventer",
  filter_confirmed: "Bekræftet",
  my_list: "Min dag",
  todo_adjust_list: "Rediger liste",
  apply: "Anvend",
  filter_assigned_to_me: "Mine opgaver",
  filter_assigned_by_me: "Delegeret",
  todo_project_label: "Projekt:",
  assigned_users: "Tildelte brugere:",
  todo_chat_label: "Chat:",
  history: "Historik",
  todo_assigned_by: "Tildelt af:",
  todo_assigned_push: "Tildelt ToDo:",
  todo_assigned_push_empty: "En ny ToDo er tildelt dig.",
  search_groups: "Grupper",
  search_chat_groups: "Chatgrupper",
  search_project_room: "Projekt",
  search_messages_tab: "Beskeder",
  searching_groups: "Søger efter grupper...",
  searching_rooms: "Søger efter projekter...",
  no_groups_found: "Ingen grupper fundet",
  no_rooms_found: "Ingen projekter fundet",
  // ToDo filter translations
  todo_filters: "Filtre",
  todo_filter_by_project: "Filtrer efter projekt",
  todo_status: "Status",
  todo_assignment: "Tildeling",
  todo_filter_by_user: "Filtrer efter tildelt person",
  todo_active_filters: "Aktive filtre:",
  todo_progress: "Fremskridt",
  todo_my_list_empty: "Din dag er tom",
  todo_my_list_empty_hint: "Klik på knappen ovenfor for at tilføje opgaver",
  create_poll: "Afstemning",
  poll_question_label: "SPØRGSMÅL",
  poll_question_placeholder: "Stil et spørgsmål",
  poll_options_label: "VALGMULIGHEDER",
  poll_option: "Valgmulighed",
  poll_add_option: "Tilføj valgmulighed",
  poll_allow_multiple: "Tillad flere svar",
  poll_multiple_allowed: "Vælg en eller flere muligheder",
  poll_select_option: "Vælg en mulighed",
  poll_view_votes: "Se stemmer",
  poll_vote_singular: "stemme",
  poll_vote_plural: "stemmer",
  poll_votes: "Afstemningsresultat",
  poll_no_votes_yet: "Ingen stemmer endnu",
  transcript_step_processing: "Transskription i gang...",
  ai_transcript_tab: "AI-Transskription",
  ai_transcript_info: "Kun tilgængelig for stemmebeskeder oprettet efter 09.03.2026.",
  transcript_more: "...mere",
  transcript_less: "...mindre",
  ki_transcript_voice_message: "KI-Transskription af talebesked",
  ki_image_analysis: "AI-understøttet billedanalyse",
  type_message: "Skriv en besked",
  email_tab_messages: "Beskeder",
  email_tab_email: "E-mail",
  email_tab_messages_and_email: "Messages & E-Mail",
  email_tab_email_details: "E-Mail Details",
  email_accounts: "E-mailkonti",
  email_connect_gmail: "Forbind Gmail",
  email_connect_outlook: "Forbind Outlook",
  email_no_accounts: "Ingen e-mailkonti forbundet",
  email_no_accounts_hint: "Forbind en e-mailkonto i dine profilindstillinger",
  email_no_messages: "Ingen e-mails",
  email_from: "Fra",
  email_to: "Til",
  email_subject: "Emne",
  email_disconnect: "Afbryd forbindelse",
  email_disconnect_confirm: "Er du sikker på, at du vil afbryde forbindelsen til denne e-mail-konto? Alle synkroniserede e-mails vil blive fjernet.",
  email_account_disconnected: "E-mailkontoen er frakoblet",
  email_account_disconnect_failed: "Kunne ikke frakoble kontoen",
  email_connecting: "Opretter forbindelse...",
  email_account_connected: "Konto forbundet succesfuldt",
  email_signature: "Signature",
  email_signature_placeholder: "Enter your email signature...",
  email_signature_save: "Save",
  email_signature_saved: "Saved",
  email_go_to_settings: "Gå til indstillinger",
  email_date: "Dato",
  email_reply: "Svar",
  email_forward: "Videresend",
  email_copy_text: "Kopiér tekst",
  email_text_copied: "Kopieret!",
  email_text_copy_failed: "Teksten kunne ikke kopieres.",
  email_delete: "Slet",
  email_not_spam: "Ikke spam",
  email_not_spam_success: "E-mail flyttet til indbakke.",
  email_not_spam_failed: "Kunne ikke flytte til indbakke.",
  email_delete_confirm: "Er du sikker på, at du vil slette denne e-mail?",
  email_delete_from_folder: "Er du sikker på, at du vil slette fra {folder}?",
  email_delete_permanent_from_folder:
    "Er du sikker på, at du vil slette permanent fra {folder}? Denne handling kan ikke fortrydes.",
  email_save_draft_confirm: "Vil du gemme denne e-mail som kladde?",
  email_save_draft: "Gem kladde",
  email_discard: "Kassér",
  email_back_to_compose: "Tilbage til skrivning",
  email_draft_saved: "Kladde gemt.",
  email_draft_save_failed: "Kunne ikke gemme kladde.",
  email_loading: "Indlæser e-mails...",
  email_archived: "Archived",
  email_mark_spam: "Mark as spam",
  email_marked_spam: "Marked as spam",
  email_group_today: "Today",
  email_group_yesterday: "Yesterday",
  email_group_this_week: "This week",
  email_group_earlier: "Earlier",
  email_search: "Search",
  email_search_placeholder: "Search mail",
  email_no_results: "No matching messages",
  email_clear_search: "Clear search",
  email_star: "Star",
  email_unstar: "Unstar",
  email_starred: "Starred",
  email_folder_starred: "Starred",
  email_select: "Vælg",
  email_attachment_singular: "Vedhæftning",
  email_attachment_plural: "Vedhæftninger",
  email_back: "Tilbage",
  email_download: "Download",
  email_close: "Luk",
  email_preview: "Forhåndsvisning",
  email_preview_not_available: "Forhåndsvisning ikke tilgængelig",
  email_preview_failed: "Forhåndsvisning ikke tilgængelig",
  select_attachments: "Vælg vedhæftninger",
  email_loading_preview: "Indlæser forhåndsvisning...",
  email_mark_unread_failed: "e-mail(s) kunne ikke markeres som ulæste.",
  email_delete_failed: "e-mail(s) kunne ikke slettes.",
  filter_all: "Alle",
  filter_email: "E-Mail",
  filter_kjuup_messages: "Kjuup",
  filter_direct_messages: "Direkte beskeder",
  my_notes: "My Space",
  filter_internal_groups: "Interne gruppechats",
  filter_external_groups: "Eksterne gruppechats",
  filter_group_chats: "Gruppechats",
  filter_groups_internal: "Interne",
  filter_groups_external: "Eksterne",
  filter_unread_only: "Kun ulæste",
  room_daily_briefing_info: "Når den er aktiveret, genereres en rapport for dette projekt hver 24. time på det tidspunkt, der er angivet i dine personlige indstillinger — men kun hvis der har været aktivitet i den periode.",
  email_select_all: "Vælg alle",
  email_deselect_all: "Fravælg alle",
  email_reply_all: "Svar alle",
  email_reply_placeholder: "Skriv dit svar...",
  email_forward_placeholder: "Tilføj en besked...",
  email_edit_draft: "Rediger kladde",
  email_attach: "Vedhæft",
  email_attachment_from_original: "Fra den originale besked",
  email_remove: "Fjern",
  email_drop_files: "Slip filer for at vedhæfte",
  email_loading_attachments: "Indlæser vedhæftninger...",
  email_archive: "Arkiver",
  mark_unread: "Markér som ulæst",
  mark_read: "Markér som læst",
  email_all_accounts: "Alle konti",
  email_error: "Fejl",
  email_delete_email_failed: "E-mail kunne ikke slettes.",
  enter_url: "Indtast URL",

  // ─── Kjuup subscription ───────────────────────────────────────────
  kjuup_io: 'Kjuup.io',
  kjuup_io_manage_subscription: 'Manage your subscription',
  kjuup_io_subscribe_now: 'Abonner nu',
  kjuup_io_hero_subtitle: 'Upgrade to unlock premium features and get more out of every project.',
  kjuup_io_trial_badge: '1 MÅNEDS GRATIS PRØVEPERIODE',
  kjuup_io_trial_title: 'Unlock Kjuup.io Premium',
  kjuup_io_trial_subtitle: 'Connect your email, receive AI-powered smart replies and synchronize your tasks with your calendar.',
  kjuup_io_trial_no_payment: 'No payment today.',
  kjuup_io_trial_trust: 'Ingen betaling i dag. Der bliver ikke bedt om kreditkortoplysninger, før det betalte abonnement starter.',
  kjuup_io_after_trial_monthly: 'After trial: {price}/month',
  kjuup_io_after_trial_yearly: 'After trial: {price}/year',
  kjuup_io_price_per_month: '{price}/month',
  kjuup_io_price_per_year: '{price}/year',
  kjuup_io_start_free_trial: 'Start free now � no risk',
  kjuup_io_trial_footnote: 'No payment today. Then {price}. Cancel anytime.',
  kjuup_io_feature_email: 'Administrer alle e-mailkonti direkte i Kjuup',
  kjuup_io_feature_assign: 'Automatically assign emails and attachments to projects',
  kjuup_io_feature_ai: 'AI skriver svar – du bekræfter bare',
  kjuup_io_feature_tasks: 'Opgaver & kalender altid automatisk opdateret',
  kjuup_io_choose_plan: 'Vælg plan',
  kjuup_io_plan_monthly: 'Månedlig',
  kjuup_io_plan_yearly: 'Årlig',
  kjuup_io_plan_monthly_desc: 'Billed monthly · cancel anytime',
  kjuup_io_plan_yearly_desc: 'Save {pct}% with annual booking',
  kjuup_io_save_badge: 'SAVE {pct}%',
  kjuup_io_per_month_annual: '{price} / month · Save {pct}% with annual booking',
  kjuup_io_subscribe: 'Subscribe',
  kjuup_io_secured_stripe: 'Sikret af Stripe · kan opsiges når som helst',
  kjuup_io_your_subscription: 'YOUR SUBSCRIPTION',
  kjuup_io_status_active: 'ACTIVE',
  kjuup_io_status_cancels_soon: 'CANCELS SOON',
  kjuup_io_status_switch_scheduled: 'SWITCH SCHEDULED',
  kjuup_io_label_plan: 'Plan',
  kjuup_io_label_price: 'Price',
  kjuup_io_label_status: 'Status',
  kjuup_io_label_renews: 'Renews on',
  kjuup_io_label_access_until: 'Access until',
  kjuup_io_switching_to: 'Switching to {plan} on {date}',
  kjuup_io_cancel_pending_note: 'Your subscription is set to cancel and won\'t renew. You keep access until the date above.',
  kjuup_io_resume: 'Resume subscription',
  kjuup_io_switch_to_plan: 'Switch to {plan} plan',
  kjuup_io_undo_switch: 'Undo scheduled change',
  kjuup_io_cancel_subscription: 'Cancel subscription',
  kjuup_io_switch_modal_title: 'Switch to {plan} plan?',
  kjuup_io_billed_yearly: 'Billed yearly',
  kjuup_io_billed_monthly: 'Billed monthly',
  kjuup_io_switch_modal_note: 'Starts on {date}, when your current {plan} plan ends. No charge today — you keep your current plan until then.',
  kjuup_io_confirm_switch: 'Confirm switch',
  kjuup_io_not_now: 'Not now',
  kjuup_io_cancel_modal_title: 'Cancel subscription?',
  kjuup_io_cancel_modal_note: 'You\'ll keep access to Kjuup.io until the end of your current billing period. After that it won\'t renew.',
  kjuup_io_cancel_modal_note_with_date: 'You\'ll keep access to Kjuup.io until the end of your current billing period ({date}). After that it won\'t renew.',
  kjuup_io_cancel_plan: 'Cancel plan',
  kjuup_io_keep_subscription: 'Keep my subscription',
  kjuup_io_toast_payment_failed: 'Payment failed',
  kjuup_io_toast_activating: 'Betaling modtaget. Dit abonnement aktiveres…',
  kjuup_io_toast_activating_soon: 'Betaling modtaget. Dit abonnement aktiveres om lidt.',
  kjuup_io_toast_cancel_period: 'Your subscription will cancel at the end of the period',
  kjuup_io_toast_cancel_fail: 'Unable to cancel subscription',
  kjuup_io_toast_switch_scheduled: 'You\'ll move to the {plan} plan when your current period ends',
  kjuup_io_toast_switch_fail: 'Unable to switch plan',
  kjuup_io_toast_resumed: 'Your subscription will keep renewing',
  kjuup_io_toast_resume_fail: 'Unable to resume subscription',
  kjuup_io_toast_undo: 'Scheduled plan change canceled',
  kjuup_io_toast_undo_fail: 'Unable to cancel the scheduled change',
  kjuup_io_email_locked_body: 'Email is part of Kjuup.io. Activate a plan to use the Email tab.',
  kjuup_io_connect_email: 'Connect email with Kjuup.io',
  kjuup_io_activate_to_connect_email: 'Activate Kjuup.io to connect email accounts',

  kjuup_io_trial_no_card: 'No credit card details are requested before your paid subscription starts.',
  kjuup_io_status_trialing: 'TRIAL',
  kjuup_io_trial_days_left: '{days} days left in your free trial',
  kjuup_io_trial_left_hours: '{count} timer tilbage',
  kjuup_io_trial_left_hour: '1 time tilbage',
  kjuup_io_trial_left_minutes: '{count} minutter tilbage',
  kjuup_io_trial_left_minute: '1 minut tilbage',
  kjuup_io_trial_left_seconds: '{count} sekunder tilbage',
  kjuup_io_trial_left_second: '1 sekund tilbage',
  kjuup_io_trial_ending_now: 'Din prøveperiode udløber…',
  kjuup_io_request_timeout: 'Forbindelsen fik timeout. Prøv igen.',
  kjuup_io_info_days_free: '{days} dage helt gratis – dit abonnement starter først efter prøveperioden.',
  kjuup_io_discount_total: 'Din rabat: {percent} %',
  kjuup_io_discount_company: '{company}: {percent} %',
  kjuup_io_discount_personal: 'Personlig: {percent} %',
  kjuup_io_trial_ends_tomorrow: 'Your free trial ends tomorrow',
  kjuup_io_trial_ends_today: 'Your free trial ends today',
  kjuup_io_banner_dismiss: 'Luk',
  kjuup_io_billing_after_trial: 'You\'ll be charged after your trial ends on {date}.',
  kjuup_io_trial_ended_title: 'Din gratis prøveperiode er slut',
  kjuup_io_trial_ended_body: 'Abonnér på Kjuup.io for fortsat at bruge e-mail og andre premiumfunktioner.',
  kjuup_io_subscribe_to_continue: 'Subscribe now to continue',
  kjuup_io_trial_active_title: 'You\'re on a free trial',
  kjuup_io_trial_active_subtitle: 'Choose a plan and subscribe — billing starts when your trial ends.',
  kjuup_io_toast_trial_started: 'Din gratis prøveperiode er startet',
  kjuup_io_toast_trial_fail: 'Prøveperioden kunne ikke startes',
  kjuup_io_trial_try_month: 'Try Kjuup.io free for one month.',
  kjuup_io_per_month: 'per month',
  kjuup_io_price_month_line: '{price} / måned',
  kjuup_io_save_amount_year: 'Spar {price} om året',
  kjuup_io_billed_annually_amount: '{price} faktureres årligt',
  kjuup_io_save_yearly: 'Save {pct}% with yearly billing.',
  kjuup_io_savings_pct: '{pct}% savings',
  kjuup_io_features_title: 'Det får du:',
  kjuup_io_info_one_month_free: 'One month free',
  kjuup_io_info_plan_after_trial: 'Your selected subscription starts after the trial.',
  kjuup_io_info_cancel_trial: 'Cancel anytime during the trial.',
  kjuup_io_info_no_card: 'Intet kreditkort påkrævet – start med det samme uden betalingsoplysninger.',
  kjuup_io_info_cancel_anytime: 'Opsig når som helst – ingen binding, ingen risiko.',
  kjuup_io_cta_plan_begins: 'Your selected plan begins after the free trial.',
  kjuup_io_billing_period_aria: 'Faktureringsperiode',
  kjuup_io_subscription_info_title: 'Subscription information',
  kjuup_io_first_payment_on: 'First payment on {date}.',
  kjuup_io_renews_on: 'Renews on {date}.',
  kjuup_io_toast_card_saved: 'Betalingsmetode gemt. Du bliver opkrævet, når prøveperioden slutter.',
  calendar_sync_info: 'Synkroniser automatisk alle Kjuup ToDos med din kalender.',
  calendar_no_accounts: 'Ingen kalender er tilsluttet endnu.',
  article_new_badge: 'NY',
  article_new_posts: '{0} nye opslag',
  documents: 'Dokumenter',
  add_documents: 'Tilføj dokumenter',
  no_preview_available: 'Ingen forhåndsvisning tilgængelig',
  no_preview_hint: 'Denne filtype kan ikke forhåndsvises, men den bliver sendt alligevel.',
  max_documents_reached: 'Du kan vedhæfte op til 10 dokumenter ad gangen.',
  open_file: 'Åbn fil',
  twofa_title: 'Tofaktorgodkendelse',
  twofa_method_totp: 'Godkendelsesapp',
  twofa_method_sms: 'SMS',
  twofa_method_email: 'E-mail',
  twofa_enter_app: 'Indtast den 6-cifrede kode fra din godkendelsesapp.',
  twofa_enter_sms: 'Indtast den 6-cifrede kode, vi sendte via SMS.',
  twofa_enter_email: 'Indtast den 6-cifrede kode, vi sendte til din e-mail.',
  twofa_resend: 'Send koden igen',
  twofa_try_another: 'Prøv en anden metode',
  twofa_remember_device: 'Spørg ikke på denne enhed i 30 dage',
  twofa_sent: 'Vi har sendt en kode.',
  twofa_invalid_code: 'Koden er forkert. Prøv igen.',
  twofa_something_wrong: 'Noget gik galt. Prøv igen.',
  twofa_method_unavailable: 'Den metode er ikke tilgængelig.',
  twofa_on_desc: 'Tofaktorgodkendelse er slået til. Du skal bruge en kode, hver gang du logger ind.',
  twofa_off_desc: 'Tilføj et andet trin efter din adgangskode. Godkendelsesapps er det mest sikre.',
  twofa_methods: 'Metoder',
  twofa_on: 'Til',
  twofa_add: 'Tilføj',
  twofa_default_method: 'Standardmetode',
  twofa_default: 'Standard',
  twofa_turn_off: 'Slå fra',
  twofa_disable_hint: 'Indtast din adgangskode og en aktuel kode for at slå tofaktorgodkendelse fra.',
  twofa_disable_need: 'Indtast din adgangskode og en bekræftelseskode.',
  twofa_code_placeholder: '6-cifret kode eller reservekode',
  twofa_send_code: 'Send en kode',
  twofa_primary_updated: 'Standardmetoden er opdateret.',
  twofa_disabled: 'Tofaktorgodkendelse er nu slået fra.',
  twofa_enabled: 'Tofaktorgodkendelse er nu slået til.',
  twofa_totp_help: 'Scan denne QR-kode med Google Authenticator, Authy eller 1Password. Du kan også indtaste nøglen manuelt.',
  twofa_secret_copied: 'Nøglen er kopieret',
  twofa_sms_help: 'Angiv dit nummer i internationalt format. Vi sender en 6-cifret kode via SMS.',
  twofa_email_help: 'Vi sender en 6-cifret kode til e-mailadressen på din konto.',
  twofa_backup_title: 'Reservekoder',
  twofa_backup_help: 'Gem disse engangskoder et sikkert sted. Hver kode kan bruges én gang, hvis du mister telefonen.',
  twofa_copy_codes: 'Kopiér koder',
  twofa_codes_copied: 'Reservekoderne er kopieret',
  twofa_regenerate: 'Hent nye reservedkoder',
  twofa_regenerate_hint: 'Dette erstatter ubrugte reservedkoder. Indtast din adgangskode og en aktuel kode.',
  twofa_backup_remaining: '{n} ubrugte reservedkoder tilbage',
  twofa_new_codes: 'Nye reservedkoder',
  twofa_sms_unavailable: 'SMS-koder er endnu ikke tilgængelige.',
  todoist_sync_title: "Todoist",
  todoist_sync_info: "Tildelte Kjuup-opgaver kopieres til et projekt ved navn Kjuup i din Todoist. Ændringer i Todoist kopieres ikke tilbage.",
  todoist_connect: "Forbind Todoist",
  todoist_connected: "Todoist forbundet",
  todoist_connect_failed: "Todoist-forbindelse mislykkedes",
  todoist_disconnect: "Afbryd",
  todoist_disconnected: "Todoist afbrudt",
  todoist_disconnect_confirm: "Afbryd Todoist? Opgaver, der allerede ligger i Todoist, bliver. Synkroniseringen stopper.",
  todoist_sync_now: "Synkroniser nu",
  todoist_syncing: "Synkroniserer…",
  todoist_sync_done: "Synkronisering fuldført",
  todoist_sync_failed: "Synkronisering mislykkedes",
  todoist_auth_error: "Forbind Todoist igen for at fortsætte synkroniseringen.",
  todoist_last_sync: "Seneste synkronisering",
  todoist_not_connected: "Todoist er ikke forbundet",
  todoist_auth_url_failed: "Todoist-autoriseringssiden kunne ikke åbnes.",
  recommend_text: "Kom med i Kjuup for at holde kontakten og holde styr på din kommunikation. Saml dine kanaler, hold beskeder i de rigtige projekter, og start hver morgen med et overblik og dine opgaver – alt synkroniseret med de apps, du allerede bruger. Kom gratis i gang:",
  pro_auth_signin_title: 'Velkommen tilbage',
  pro_auth_signin_sub: 'Log ind med din arbejds-e-mail.',
  pro_auth_email_or_username: 'E-mail eller brugernavn',
  pro_auth_email_placeholder: 'navn@virksomhed.dk',
  pro_auth_forgot_password: 'Glemt adgangskode?',
  pro_auth_create_account: 'Opret konto',
  pro_auth_show_password: 'Vis adgangskode',
  pro_auth_hide_password: 'Skjul adgangskode',
  pro_auth_register_sub: 'Vi sender dig et link til at bekræfte din e-mail.',
  pro_auth_register_plus_sub: 'Vælg et brugernavn og en adgangskode. Derefter angiver du din sikkerheds-PIN.',
  pro_auth_check_credentials: 'Tjek din e-mail og adgangskode',
  pro_news_export_pdf: 'Eksportér som PDF',
  pro_news_pdf_failed: 'PDF\'en kunne ikke oprettes.',
  pro_news_pdf_attachments: 'Vedhæftninger',
  pro_news_pdf_video: 'Video',
  pro_auth_forgot_sub: 'Indtast din e-mail, så sender vi dig et link til at nulstille din adgangskode.',
  pro_auth_send_link: 'Send nulstillingslink',
  pro_auth_plus_reset: 'Nulstil med PIN',
  pro_auth_show_pin: 'Vis PIN',
  pro_auth_hide_pin: 'Skjul PIN',
  v2_auth_plus_only: 'Kun Kjuup+',
  room_action_media: "Filer",
  room_tab_overview: "Oversigt",
  room_tab_history: "Historik",
  chat_info_media: "Filer",
  messages: "beskeder",
  pro_todo_project_required: "Vælg venligst et projekt",
  pro_todo_choose_project: "Hvilket projekt er opgaven til?",
  cockpit_report_delete_confirm: "Slet denne dagsrapport?",
  cockpit_report_deleted: "Dagsrapport slettet",
  cockpit_tab_company: "Virksomhed",
  cockpit_bookmarked_priorities: "Markerede opgaver",
  cockpit_load_error: "Cockpit kunne ikke indlæses.",
  cockpit_retry: "Prøv igen",
  cockpit_yesterday: "I går",
  cockpit_greeting_morning: "God morgen",
  cockpit_greeting_day: "God dag",
  cockpit_greeting_evening: "God aften",
  cockpit_assistant_q_open: "Hvad er åbent i dag?",
  cockpit_assistant_q_summarize: "Opsummer chatten {{room}}",
  cockpit_assistant_q_overdue: "Hvilke opgaver er forfaldne?",
  cockpit_assistant_new: "{{n}} nye",
  cockpit_assistant_important: "{{n}} vigtige",
  cockpit_assistant_title: "Kjuup-assistent",
  cockpit_assistant_hint: "Tryk og spørg",
  room_overview_priority_no_detail: "Rapporten giver ikke flere detaljer om denne prioritet.",
  room_overview_priority_from: "Kilde: {{name}}",
  room_overview_priority_open_task: "Åbn opgave",
  cockpit_priority_position: "{{index}} af {{total}} prioriteter",
  room_overview_today_title: "Vigtigt i dag",
  room_overview_all_tasks: "Alle",
  room_overview_tasks_empty: "Ingen åbne frister eller opgaver",
  room_overview_appointments_empty: "Ingen kommende aftaler",
  room_overview_no_priorities: "Ingen åbne prioriteter i den seneste rapport.",
  cockpit_report_top5: "Top 5 prioriteter",
  cockpit_report_todo_created: "Opgave oprettet",
  cockpit_report_source_missing: "Kildebeskeden blev ikke fundet.",
  delete_bookmarked_priority_confirm: "Er du sikker på, at du vil slette denne markerede opgave?",
  cockpit_report_create_todo: "Opret opgave",
  cockpit_priorities_deleting: "Sletter …",
  cockpit_priorities_select: "Slet flere",
  cockpit_report_none: "Ingen poster.",
  cockpit_priorities_delete_confirm: "Er du sikker på, at du vil slette {count} markerede opgaver?",
  cockpit_priorities_delete_failed: "{count} opgaver kunne ikke slettes",
  cockpit_priorities_deleted: "{count} opgaver slettet",
  cockpit_priorities_selected: "{count} valgt",
  cockpit_channel_connected: "Forbundet",
  cockpit_channel_not_connected: "Ikke forbundet",
  cockpit_channel_connect: "Forbind",
  cockpit_channel_chat: "Kjuup-chat",
  cockpit_channel_active: "Aktiv",
  cockpit_channel_hidden: "Skjult",
  cockpit_channel_enable: "Aktivér",
  cockpit_channel_email: "E-mail",
  cockpit_channel_check: "Kontrollér forbindelsen",
  cockpit_channel_fix: "Kontrollér",
  cockpit_channel_forward: "Videresendelsesadresse",
  cockpit_channel_not_set_up: "Ikke konfigureret",
  cockpit_channel_set_up: "Konfigurér",
  cockpit_channel_teams: "Microsoft Teams",
  cockpit_channel_broken: "Forbindelsen er afbrudt",
  cockpit_channel_importing: "Importerer",
  cockpit_channel_removing: "Afbryder",
  cockpit_channel_reconnect: "Forbind igen",
  cockpit_channels_title: "Kanaler",
  cockpit_company_role_super_admin: "Virksomhedsadministrator",
  cockpit_company_role_dept_admin: "Afdelingsadministrator",
  cockpit_company_role_member: "Medarbejder",
  cockpit_company_none: "Ingen Kjuup+-virksomhed fundet",
  cockpit_company_eyebrow: "Virksomhed",
  cockpit_company_inactive: "inaktiv",
  cockpit_company_settings: "Virksomhedsindstillinger",
  cockpit_company_employees: "Medarbejdere",
  cockpit_company_internal_rooms: "Interne projekter",
  cockpit_report_all_projects: "Alle projekter",
  cockpit_report_progress_emails: "Analyserer e-mails",
  cockpit_report_progress_chats: "Analyserer chatbeskeder",
  cockpit_report_progress_documents: "Analyserer vedhæftede filer og dokumenter",
  cockpit_report_progress_tasks: "Analyserer opgaver",
  cockpit_report_progress_summarizing: "Analyserer indhold",
  cockpit_report_progress_reading: "Genbruger indhold, der allerede er analyseret",
  cockpit_report_progress_collecting: "Indsamler e-mails, chats og opgaver fra dine projekter",
  cockpit_report_progress_priorities: "Sammensætter prioriteter, frister og beslutninger",
  cockpit_report_progress_queued: "Forbereder rapporten",
  cockpit_report_creating_title: "Din dagsrapport bliver forberedt",
  cockpit_report_progress_count_one: "1 element analyseret",
  cockpit_report_progress_count_many: "{{count}} elementer analyseret",
  cockpit_report_progress_hint: "Det tager normalt et til to minutter – du kan fortsætte med at bruge cockpit i mellemtiden.",
  cockpit_report_time_hint: "Dagsrapporten oprettes hver dag kl. {{hour}}:00 for de fem mest aktive projekter.",
  room_overview_priorities_title: "Aktuel status og prioriteter",
  room_overview_as_of: "Pr. {{time}}",
  cockpit_report_delete: "Slet dagsrapport",
  email_tag_daily_briefing: "Dagsrapport",
  cockpit_report_unread: "Ny",
  cockpit_report_clear_project: "Vis alle projekter",
  cockpit_filter_project: "Projekt",
  cockpit_filter_all_projects: "Alle projekter",
  cockpit_report_recreate: "Opret dagsrapport igen",
  cockpit_report_hide_previous: "Skjul tidligere dagsrapporter",
  cockpit_report_show_previous: "Vis tidligere dagsrapporter",
  cockpit_report_room_empty: "Endnu ingen dagsrapport for dette projekt",
  cockpit_report_empty: "Endnu ingen dagsrapport",
  cockpit_report_room_empty_hint: "Opret en dagsrapport kun for dette projekt.",
  cockpit_report_needs_mailbox: "Forbind en e-mailkonto, så Kjuup kan oprette en dagsrapport med automatiske opgaver.",
  cockpit_report_create: "Opret dagsrapport",
  cockpit_email_connect: "Forbind e-mail",
  cockpit_email_none_title: "Endnu ingen e-mailkonto forbundet",
  cockpit_email_none_reports: "Forbind din postkasse, så Kjuup kan tildele indkommende e-mails til dine projekter og oprette dagsrapporter med opgaver.",
  cockpit_email_none_client: "Forbind Gmail, Outlook eller IMAP for at læse, tildele og besvare e-mails direkte i Kjuup.io.",
  cockpit_email_reports_title: "Nuværende e-mailklient",
  cockpit_email_reports_text: "Ingen indbakke i Kjuup.io · {{rooms}} projekter med dagsrapport kl. {{hour}}:00 · indkommende e-mails tildeles dine projekter.",
  cockpit_email_reports_rooms: "Administrer projekter",
  cockpit_email_settings: "E-mailindstillinger",
  cockpit_email_error_title: "Kontrollér forbindelsen",
  cockpit_email_client_title: "Indbakke forbundet",
  cockpit_email_accounts_n: "{{n}} konto forbundet",
  cockpit_email_last_sync: "seneste synkronisering {{when}}",
  cockpit_email_report_at: "Dagsrapport kl. {{hour}}:00",
  cockpit_email_open_inbox: "Åbn indbakken",
  cockpit_email_eyebrow: "Kjuup-e-mail",
  cockpit_email_accounts_label: "Forbundne e-mailadresser",
  email_folder_sent: "Sendt post",
  email_no_subject: "(Intet emne)",
  cockpit_email_detail_loading: "Indlæser e-mail …",
  cockpit_email_detail_failed: "E-mailen kunne ikke indlæses.",
  cockpit_email_detail_empty: "Denne e-mail har ingen tekst.",
  cockpit_personal_settings: "Personlige indstillinger",
  cockpit_companies: "Virksomheder",
  cockpit_title: "Cockpit",
  cockpit_back: "Tilbage til oversigten",
  cockpit_day_overview: "Din dag på et overblik",
  email_saved_to_project: "E-mail gemt i projektet",
  email_classify_need_project: "Angiv et projektnavn",
  cockpit_email_deleted: "E-mail slettet",
  cockpit_email_sent_empty: "Endnu ingen sendte e-mails.",
  cockpit_email_incoming_empty: "Endnu ingen indkommende e-mails.",
  cockpit_email_incoming_title: "E-mails",
  cockpit_email_incoming_sub: "Tildel indkommende og sendte e-mails til dine projekter. Du kan justere tildelingen her.",
  cockpit_email_incoming_unassigned_n: "{{n}} ikke tildelt",
  cockpit_email_folder_inbox: "Indbakke",
  cockpit_email_folder_sent: "Sendt",
  cockpit_email_open: "Åbn e-mail",
  cockpit_email_incoming_suggested: "Forslag: {{room}}",
  cockpit_email_incoming_apply: "Anvend",
  cockpit_email_incoming_adjust: "Juster tildeling",
  cockpit_email_incoming_saving: "Gemmer …",
  cockpit_email_incoming_unassigned: "Ikke tildelt",
  cockpit_email_incoming_show_less: "Vis færre",
  cockpit_email_incoming_show_all: "Vis alle {{n}}",
  cockpit_io_settings: "Kjuup.io-indstillinger",
  cockpit_io_settings_sub: "Abonnement og pladser, tildeling af medarbejdere, fakturering og fakturaer.",
  products_coming_soon: "Kommer snart",
  cockpit_upsell_io_title: "Dit kontor, der tænker med",
  cockpit_upsell_io_text: "Forbind dine e-mailkonti med Kjuup. E-mails, vedhæftede filer og beskeder gemmes automatisk i det rette projekt og kan om ønsket lagres på din server. Hver dag får du et resumé af alle projekter med hovedpunkterne fra alt indhold, og dine opgaver synkroniseres med din kalender eller to do-app.",
  cockpit_upsell_io_soon_title: "Kan endnu ikke bestilles",
  cockpit_upsell_io_soon_text: "Kjuup.io lanceres snart. Bed om information nu – vi giver dig besked, så snart du kan bestille Kjuup.io.",
  cockpit_upsell_io_planned_price: "Planlagt pris",
  cockpit_upsell_io_cta_request: "Bed om information",
  kjuup_plus_abo_per_year: "/ år",
  kjuup_plus_abo_per_month: "/ måned",
  kjuup_plus_abo_status_active: "Aktiv",
  kjuup_plus_abo_status_requested: "Opsigelse anmodet",
  kjuup_plus_abo_status_past_due: "Betaling forfalden",
  kjuup_plus_abo_eyebrow: "Kjuup+ · Abonnement",
  kjuup_plus_abo_title: "Kjuup+-pakke",
  kjuup_plus_abo_seats_free_one: "1 plads tilbage",
  kjuup_plus_abo_billing: "Fakturering",
  kjuup_plus_abo_yearly: "Årligt",
  kjuup_plus_abo_monthly: "Månedligt",
  kjuup_plus_abo_amount: "Beløb",
  kjuup_plus_abo_ends: "Udløber den",
  kjuup_plus_abo_renews: "Næste fornyelse",
  kjuup_plus_abo_next_invoice: "Næste faktura",
  kjuup_plus_abo_intro: "Introduktionspris",
  kjuup_plus_abo_pending_tier: "Fra næste fornyelse",
  kjuup_plus_abo_manual: "Kjuup+ er aktivt for din virksomhed i henhold til en individuel aftale.",
  kjuup_plus_abo_invoices: "Fakturaer",
  kjuup_plus_abo_invoice_paid: "Betalt",
  kjuup_plus_abo_invoice_view: "Vis",
  kjuup_plus_abo_invoices_less: "Vis færre",
  kjuup_plus_abo_member_hint: "Fakturering og opsigelse administreres af jeres virksomhedsadministratorer.",
  kjuup_plus_abo_withdraw: "Træk anmodning tilbage",
  kjuup_plus_abo_cancel_note: "Begrundelse (valgfrit)",
  kjuup_plus_abo_cancel_send: "Anmod om opsigelse",
  kjuup_plus_abo_cancel: "Opsig abonnement",
  cockpit_upsell_plus_f1: "Administrer alle medarbejderes kommunikationsaktivitet",
  cockpit_upsell_plus_f2: "Informer bestemte brugergrupper i virksomheden",
  cockpit_upsell_plus_f3: "Gem interne gruppechats",
  cockpit_upsell_plus_when_yearly: "ved årlig betaling",
  cockpit_upsell_plus_size_small: "1–50 medarbejdere",
  cockpit_upsell_plus_size_large: "51–200 medarbejdere",
  cockpit_upsell_plus_title: "Kjuup+ til virksomheder",
  cockpit_upsell_plus_text: "Administrer medarbejdere, skrivetilladelser og virksomhedskommunikation ét sted. Interne kanaler bliver hos dit team, eksterne kanaler forbinder dig med projektpartnere, og du kan nå bestemte grupper direkte. Ud over Kjuup+ kan du bestille Kjuup.io-adgang til medarbejdergrupper. Kjuup+ og Kjuup.io kan kombineres.",
  cockpit_upsell_plus_size: "Virksomhedsstørrelse",
  cockpit_upsell_plus_billing: "Fakturering",
  cockpit_upsell_plus_per_company: "/ virksomhed · måned ekskl. moms",
  cockpit_upsell_plus_onboarding: "Omkostninger til onboarding/introduktion afhænger af virksomhedens størrelse",
  cockpit_upsell_plus_larger: "Priser for større virksomheder på forespørgsel",
  cockpit_upsell_plus_cta: "Uforpligtende forespørgsel",
  cockpit_kpi_deadlines_tasks: "Frister og opgaver",
  cockpit_kpi_appointments: "Aftaler",
  cockpit_room_admin: "Projekt- og chatadministration",
  cockpit_room_admin_sub: "Alle virksomhedens projekter med medlemmer, medier og chats.",
  pro_todo_not_found: "Denne opgave er ikke længere tilgængelig.",
  cockpit_chip_overdue: "Forfalden",
  cockpit_chip_today: "I dag",
  cockpit_calendar_week: "Uge {{week}}",
  cockpit_prev_week: "Forrige uge",
  cockpit_next_week: "Næste uge",
  cockpit_chip_requested: "Anmodet",
  cockpit_todo_due: "Frist {{when}}",
  cockpit_todo_at: "{{time}}",
  cockpit_todo_requested_from: "fra {{name}}",
  cockpit_todo_since: "siden {{when}}",
  cockpit_todo_no_date: "Ingen dato",
  cockpit_todo_mark_done: "Markér som udført",
  cockpit_my_tasks_title: "Mine opgaver",
  cockpit_today_tasks_group: "Dagens opgaver",
  cockpit_assign_none: "Ingen tildelt",
  no_project_found: "Intet projekt fundet",
  cockpit_row_more_actions: "Flere handlinger",
  needs_date: "Tildel dato",
  cockpit_assign_proposal: "{{name}} genkendt – tildel?",
  cockpit_assign_proposal_confirm: "Tildel",
  cockpit_assign_proposal_dismiss: "Ignorer",
  cockpit_priority_date: "Dato",
  todo_calendar_add: "Føj til kalender",
  todo_calendar_remove: "Fjern fra kalender",
  cockpit_todo_change_project: "Skift projekt",
  cockpit_todo_set_date: "Angiv dato",
  pro_todo_done_confirm: "Vil du virkelig markere denne opgave som udført?",
  cockpit_task_delete_failed: "Opgaven kunne ikke slettes.",
  cockpit_setup_title: "Afslut opsætningen",
  cockpit_setup_text: "Beslut, om du vil bruge chats, og om Kjuup.io skal fungere som e-mailklient eller kun med projekter og dagsrapporter.",
  cockpit_setup_cta: "Konfigurér nu",
  cockpit_group_tasks: "Frister og opgaver",
  cockpit_group_appointments: "Aftaler",
  cockpit_report_no_activity: "Dette projekt havde ingen nye beskeder eller e-mails i de seneste 24 timer.",
  cockpit_report_room_unavailable: "Dette projekt er ikke tilgængeligt.",
  cockpit_report_create_failed: "Dagsrapporten kunne ikke oprettes.",
  cockpit_report_created: "Dagsrapport oprettet",
  addon_enable_confirm: "Aktivér tilføjelsen?",
  addon_enable: "Aktivér",
  addon_enabled: "Tilføjelse aktiveret",
  nav_email: "E-mail",
  nav_my_cockpit: "Mit cockpit",
  nav_news: "Nyheder",
  nav_recommend: "Anbefal",
  pro_todo_status_done: "Udført",
  pro_todo_status_open: "Åben",
  v2_todo_remove: "Fjern",
  pro_todo_search_people: "Søg efter personer",
  pro_todo_clear: "Ryd",
  pro_todo_assigned: "(tildelt)",
  pro_todo_no_people: "Ingen personer fundet",
  pro_todo_search_rooms: "Søg efter projekter",
  pro_todo_no_rooms_match: "Ingen projekter matcher “{{q}}”",
  pro_todo_no_rooms: "Ingen projekter fundet",
  pro_todo_activity: "Aktivitet",
  pro_todo_show_less: "Vis færre",
  pro_todo_show_all: "Vis alle ({{n}})",
  pro_todo_due: "Frist",
  pro_todo_room: "Projekt",
  pro_todo_select_room: "Vælg projekt",
  pro_todo_status: "Status",
  pro_todo_more: "Mere",
  pro_todo_edit_title: "Rediger opgave",
  pro_todo_description: "Beskrivelse",
  pro_todo_created_by: "Oprettet af",
  pro_todo_chat: "Chat",
  navigate_to_source: "Gå til kilden",
  todo_calendar_connect_title: "Ingen kalender forbundet",
  todo_calendar_connect_body_web: "Forbind en kalender i indstillingerne for kalendersynkronisering for at føje opgaver til den.",
  todo_calendar_connect: "Forbind",
  todo_calendar_removed: "Fjernet fra din kalender",
  todo_calendar_added_later: "Tilføjet. Din kalender kunne ikke kontaktes; Kjuup prøver igen senere.",
  todo_calendar_added: "Føjet til din kalender",
  todo_calendar_no_date: "Kun en opgave med dato kan føjes til en kalender.",
  todo_calendar_failed: "Din kalender kunne ikke opdateres. Prøv igen.",
  todo_calendar_date_title: "Endnu ingen dato",
  todo_calendar_date_save: "Angiv dato og føj til",
  todo_calendar_date_body_web: "Denne markerede opgave har endnu ingen dato. Angiv en for at føje den til din kalender.",
  kjuup_io_setup_saved: "Opsætning gemt",
  kjuup_io_setup_step: "Trin",
  kjuup_io_setup_chats_title: "Vil du bruge chats?",
  kjuup_io_setup_email_title: "Hvor vil du læse dine e-mails?",
  kjuup_io_setup_chats_sub: "Chats med kolleger og projektpartnere er valgfrie. Du kan til enhver tid vise eller skjule dem i cockpit.",
  kjuup_io_setup_email_sub: "Det afgør kun, om du bruger en e-mailklient i Kjuup, eller om du fortsat bruger dit nuværende e-mailprogram, f.eks. Outlook eller et andet. Du kan skifte senere.",
  kjuup_io_setup_chats_yes: "Ja, vis chats",
  kjuup_io_setup_chats_yes_text: "Beskeder indeholder chats og e-mails. Projekter har gruppechats for alle involverede.",
  kjuup_io_setup_chats_no: "Nej, arbejd uden chats",
  kjuup_io_setup_chats_no_text: "Chats er skjult. “Beskeder” bliver til “E-mail”; projekter, opgaver og dagsrapporter forbliver.",
  kjuup_io_setup_email_client: "E-mailklient i Kjuup",
  kjuup_io_setup_email_client_text: "Læs og besvar e-mails direkte i Kjuup.",
  kjuup_io_setup_email_reports: "Nuværende e-mailklient",
  kjuup_io_setup_email_reports_text: "Bliv ved med at læse og svare i dit nuværende program, f.eks. Outlook eller et andet.",
  kjuup_io_setup_skip: "Senere",
  next: "Næste",
  kjuup_io_setup_finish: "Afslut opsætningen",
  today_label: "i dag",
  tomorrow_label: "i morgen",
  cockpit_todo_overdue: "forfalden",
  cockpit_report_management_fazit: "Resumé til ledelsen",
  cockpit_todo_appointment: "Aftale",
  cockpit_todo_deadline: "Frist",
  cockpit_todo_deadline_define: "Angiv frist",
  pro_todo_status_acknowledged: "Bekræftet",
  pro_todo_responsible: "Ansvarlig",
  pro_todo_notice_confirmed: "Bekræftet i chatten",
  pro_todo_notice_sent_at: "Besked sendt",
  pro_todo_notice_again: "Send beskeden igen",
  pro_todo_notice_send: "Informer via Kjuup-besked",
  pro_todo_add_assignee: "Tilføj",
  pro_todo_edit: "Rediger",
  pro_todo_change_room: "Skift projekt",
  pro_todo_due_on: "Frist den",
  pro_todo_edit_due: "Rediger frist",
  pro_todo_no_date: "Ingen dato",
  pro_todo_edit_description: "Rediger beskrivelse",
  pro_todo_no_description: "Endnu ingen beskrivelse",
  pro_todo_title_label: "Titel",
  pro_todo_title_placeholder: "Indtast titel...",
  pro_todo_task: "Opgave",
  pro_todo_what: "Hvad skal gøres?",
  pro_todo_source_email: "E-mail",
  pro_todo_sources: "Kilder",
  previous: "Forrige",
  kjuup_plus_abo_tier_large: "Kjuup+ Large (op til {max} medarbejdere)",
  kjuup_plus_abo_tier_small: "Kjuup+ Small (op til {max} medarbejdere)",
  kjuup_plus_abo_status_ends: "Slutter den {date}",
  kjuup_plus_abo_seats_over: "Mere end {max} medarbejdere – Kjuup kontakter dig med et individuelt tilbud.",
  kjuup_plus_abo_seats_next: "Kommer der flere medarbejdere til, skifter pakken automatisk til {next} (forholdsmæssigt beregnet).",
  kjuup_plus_abo_seats_used: "{used} af {total} pladser i brug",
  kjuup_plus_abo_seats_free: "{count} pladser tilbage",
  kjuup_plus_abo_intro_until: "indtil {date}",
  kjuup_plus_abo_invoice_open: "Åben · forfalder {date}",
  kjuup_plus_abo_invoices_all: "Vis alle {count}",
  kjuup_plus_abo_requested_hint: "Opsigelse anmodet den {date}. Kjuup bekræfter den ved periodens udløb ({end}).",
  kjuup_plus_abo_cancel_hint: "Kjuup gennemgår din anmodning og bekræfter opsigelsen ved periodens udløb ({end}). Indtil da forbliver Kjuup+ aktiv.",
  kjuup_plus_abo_withdrawn: "Anmodning om opsigelse trukket tilbage",
  kjuup_plus_abo_requested: "Opsigelse anmodet",
  cockpit_upsell_plus_intro_hint: "første {months} måneder, derefter {price}",
  cockpit_upsell_plus_badge: "INTROPRIS I {months} MÅNEDER",
  calendar_syncing: "Opdaterer fra kalender…",
  calendar_sync_up_to_date: "Kalenderen er ajour",
  calendar_sync_failed: "Synkronisering mislykkedes",
  delete_multiple_tasks_confirm: "Er du sikker på, at du vil slette {count} ToDo'er?",
  todos_deleted_count: "{count} ToDo'er slettet",
  todos_deleted_partial: "{ok} ToDo'er slettet, {fail} mislykkedes",
  todo_unknown: "Ukendt",
  todo_created_from_message: "Opgave oprettet fra denne besked",
  kjuup_io_todo_calendar_trial_ended_note: "Kalendersynkronisering · Abonner",
  kjuup_io_todo_calendar_nudge: "Synkroniser denne ToDo til din kalender?",
  kjuup_io_todo_calendar_nudge_cta: "Aktivér Kjuup.io",
  todo_confirmed: "ToDo bekræftet",
  pro_todo_bulk_delete_title: "Slet {{n}} opgaver?",
  pro_todo_previous_none_own: "De forfaldne opgaver er tildelt dig af andre og kan kun slettes af dem.",
  pro_todo_previous_none: "Ingen forfaldne opgaver",
  pro_todo_previous_title: "Slet {{n}} forfaldne opgaver?",
  pro_todo_previous_text: "Alle dine åbne opgaver fra tidligere dage bliver slettet.",
  pro_todo_previous_skipped: "{{n}} tildelt af andre bliver stående.",
  unassign_task_confirm: "Vil du annullere din tildeling for denne opgave?",
  unassign_label: "Annuller",
  pro_todo_delete_title: "Slet opgave",
  pro_todo_today: "I dag",
  pro_todo_yesterday: "I går",
  pro_todo_since_yesterday: "Siden i går",
  pro_todo_mark_open: "Markér som åben",
  verify_completion: "Bekræft",
  new_label: "Ny",
  bookmarked_no_mylist: "Bogmærkede opgaver kan ikke føjes til Min liste",
  delete_only_own: "Du kan kun slette opgaver, du selv har oprettet",
  todo_clear_all: "Ryd alle",
  pro_todo_of_completed: "{{done}} af {{total}} udført",
  pro_todo_pick_date: "Vælg en dato",
  pro_todo_show_day: "Vis dag",
  pro_todo_section_upcoming: "Kommende",
  pro_todo_section_done: "Udført",
  pro_todo_room_empty_today: "Ingen opgaver i dag i dette projekt",
  pro_todo_room_empty_day: "Ingen opgaver denne dag i dette projekt",
  pro_todo_delete_previous: "Slet alle",
  pro_todo_empty_title: "Intet her",
  pro_todo_empty_hint: "Ingen opgaver matcher denne visning.",
  pro_todo_selected: "{{n}} valgt",
  delete_selected_count: "Slet ({count})",
  pro_todo_adjust_done: "Færdig",
  pro_todo_deleting: "Sletter...",
  pro_todo_reopen: "Genåbn opgave",
  pro_todo_step_done: "Udført",
  move_back_in_progress: "Tilbage til i gang",
  pro_todo_mark_not_started: "Marker som ikke påbegyndt",
  back_into_in_progress: "Tilbage til i gang",
  pro_todo_mark_in_progress: "Marker som i gang",
  unassign_todo: "Annuller tildeling af ToDo",
  pro_todo_open_room: "Åbn projekt",
  pro_todo_new_task: "Ny opgave",
  select_user_back_to_in_progress: "Vælg brugeren, der skal flyttes tilbage til I gang",
  cockpit_email_accounts_n_many: "{{n}} konti forbundet",
  // Kjuup + Microsoft Teams chats (new-chat pickers, combined groups)
  combined_tab_kjuup: "Kjuup-kontakter",
  combined_tab_teams: "Teams-kontakter",
  combined_bridge_failed: "Teams-kopien kunne ikke oprettes.",
  combined_chat_label: "Kjuup + Teams",
  combined_guest_tag: "Teams",
  combined_new_group_note: "Kjuup- og Teams-kontakter: der oprettes en ny gruppe, som også vises i Microsoft Teams.",
  teams_new_chat_title: "Ny Teams-chat",
  teams_new_chat_topic: "Gruppenavn (valgfrit)",
  teams_new_chat_start: "Start chat",
  teams_new_chat_creating: "Opretter chat…",
  teams_new_chat_forbidden: "Microsoft Teams tillader ikke denne chat (f.eks. en person uden for din organisation eller en politik fra din IT).",
  teams_new_chat_too_many: "For mange personer til én chat.",
  teams_new_chat_type_hint: "Skriv et navn for at søge i din organisation.",
  teams_new_chat_directory_forbidden: "Din organisation tillader ikke søgning i kataloget. Kun personer fra dine Teams-chats vises.",
  teams_new_chat_account: "Konto",
};
